import React, { useState, useEffect } from "react";
import Logo from "../../assets/images/logo/light.png";
import Logo1 from "../../assets/images/logo/logo-new.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchProducts } from "../../apiCalls/product";
import { BiSearch, BiUser, BiHeart, BiShoppingBag } from "react-icons/bi";

const UserBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart.products);
  const user = useSelector((state) => state.user.currentUser);
  const wishlist = useSelector((state) => state.wishlist.products);
  const productList = useSelector((state) => state.products.products);
  const [input, setInput] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    fetchProducts(dispatch);
  }, [dispatch]);

  const fetchData = (value) => {
    const results = productList.filter((product) => {
      return (
        value &&
        product &&
        product.title &&
        product.title.toLowerCase().includes(value)
      );
    });
    setResults(results);
  };

  const handleChange = (value) => {
    console.log(value, "val");
    setInput(value);
    fetchData(value.toLowerCase());
  };

  console.log(input.length, "results");

  const goToProduct = (prod) => {
    // navigate({`/product/${prod._id}`})
    console.log(prod, 'prod data')
    navigate(`/product/${prod}`);
    setResults([]);
    setInput("");
  }

  return (
    <>
      <section className="userbar">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="userbar-content">
                <Link to="/" className="header-logo">
                  <img
                    src="https://www.beyoung.in/desktop/images/common/logo.png"
                    // src={Logo1}
                    alt="Shop Store"
                    width="150"
                    // height="100"
                  />
                </Link>

                <div className="header-search-container">
                  <input
                    type="search"
                    className="search-field"
                    value={input}
                    placeholder="Enter your product name..."
                    onChange={(e) => handleChange(e.target.value)}
                  />

                  <button className="search-btn">
                    <BiSearch className="search-icon" />
                  </button>

                  {results.length > 0 && input.length > 1 && (
                    <div className="suggestions">
                      {results.map((result, id) => {
                        return (
                          <h4
                          onClick={() => goToProduct(result._id)}
                            // to={`/product/${result._id}`}
                            className="search-result"
                            type="button"
                            key={result._id}
                          >
                            <p className="title-search">🔍 {result.title}</p>
                          </h4>
                        );
                      })}
                    </div>
                  )}

                  {results.length < 1 && input.length > 1 && (
                    <div className="suggestions">
                          <div className="not-found">
                            <p className="search-not-found">
                            🔍 No Product Found, Search Something Different
                            </p>
                          </div>
                    </div>
                  )}
                </div>

                <div className="header-user-actions">
                  <button className="action-btn">
                    <Link to="/my-account" className="user-icon">
                      <BiUser />
                      {user ? <span>{user?.username?.slice(0, 5)}</span> : ""}
                    </Link>
                  </button>

                  <button className="action-btn">
                    <Link to="/wishlist">
                      <BiHeart />
                      <span className="count">
                        {wishlist[0]?.listItems?.length
                          ? wishlist[0]?.listItems?.length
                          : 0}
                      </span>
                    </Link>
                  </button>

                  <button className="action-btn">
                    <Link to="/cart">
                      <BiShoppingBag />
                      <span className="count">
                        {cart[0]?.cartItems?.length
                          ? cart[0]?.cartItems?.length
                          : 0}
                      </span>
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserBar;
